import React from 'react';
import { useSystemAgreements } from '../hooks/use-system-agreements.js';
import SystemAgreementsPageView from './system-agreements-page-view.jsx';

function SystemAgreementsPageContainer() {
  const state = useSystemAgreements();
  return <SystemAgreementsPageView {...state} />;
}

export default SystemAgreementsPageContainer;

